import * as React from 'react';
import AsyncSelect from 'react-select/lib/Async';
import * as OfficeHelpers from '@microsoft/office-js-helpers';
import {Button, ButtonType} from "office-ui-fabric-react";
import {fetch as fetchPolyfill} from 'whatwg-fetch'

const URL = 'https://vita.hollandpalette.nl';

const loadOptions = (term, callback) => {
    fetchPolyfill(`${URL}/methods/searchAccountByName`, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
        redirect: "follow", // manual, *follow, error
        body: JSON.stringify(
            [
                term,
                "SUPPLIER",
                window.location.hash.replace('#','')
            ]
        )
    })
        .then(response => response.json())
        .then(result => {
            callback(result)
        });
};

export interface AppProps {
    title: string;
    isOfficeInitialized: boolean;
}

export interface AppState {}

export default class App extends React.Component<AppProps, AppState> {

    state = {
        selectedSupplier: null,
        term: '',
    };

    handleChange = (selectedSupplier) => {

        this.setState({ selectedSupplier }, async () => {
            await this.insertSupplierDetails();
        });
    };

    handleInputChange = (newValue: string) => {
        // const term = newValue.replace(/\W/g, '');
        this.setState({ term: newValue });
        return newValue;
    };

    insertSupplierDetails = async () => {
        try {
            await Word.run(async context => {
                const doc = context.document;
                const originalRange = doc.getSelection();
                const { name, billingStreet, billingCode, billingCity, phone } = this.state.selectedSupplier;

                if (!name) {
                    return;
                }

                let address = originalRange.insertText(`${name}\r${billingStreet}\r${billingCode} ${billingCity}\r${phone}`, "End");

                address.font.set({
                    name: "Arial Narrow",
                    bold: true,
                    size: 11
                });

                context.load(originalRange.paragraphs, 'alignment');

                await context.sync().then(function() {
                    originalRange.paragraphs.items.map(function(paragraph) {
                        paragraph.alignment = "Centered";
                    });
                });
            });
        } catch (error) {
            OfficeHelpers.UI.notify(error);
            OfficeHelpers.Utilities.log(error);
        }
    };

    render() {

        const { selectedSupplier } = this.state;

        return (
            <div className="vita">
                <br/><br/>
                <div className="padding">

                    <AsyncSelect
                        cacheOptions={false}
                        loadOptions={loadOptions}
                        defaultOptions
                        onInputChange={this.handleInputChange}
                        onChange={this.handleChange}

                        formatOptionLabel={(option) => <span>{option.name}</span>}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option._id}

                        placeholder="Find supplier..."
                    />

                    <div>
                        {selectedSupplier && (
                            <div>
                                <br/>
                                {selectedSupplier.name}<br/>
                                {selectedSupplier.billingStreet}<br/>
                                {selectedSupplier.billingCode} {selectedSupplier.billingCity}<br/>
                                {selectedSupplier.phone}
                            </div>
                        )}
                    </div>
                    <div>
                        <br/>
                        <Button className="normal-button" buttonType={ButtonType.hero} onClick={this.insertSupplierDetails}>Insert address</Button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./components/App.tsx